import { Injectable } from '@angular/core';

import { Observable, BehaviorSubject } from 'rxjs';
import { share } from 'rxjs/operators';

/**
 *
 *
 * @export
 * @class AlertService
 */
@Injectable()
export class OverlayService {
  private _subject = new BehaviorSubject<any>({ status: false, message: null });

  constructor() {}

  getOverlay(): Observable<any> {
    return this._subject.asObservable().pipe(share());
  }

  showOverlay(message: string) {
    this.overlay({ status: true, message: message });
  }

  hideOverlay() {
    this.overlay({ status: false, message: null });
  }

  overlay(value: any) {
    this._subject.next(value);
  }

  clear() {
    this._subject.next({ status: false, message: null });
  }
}
